export const GET_CITY = "GET_CITY"
export const GET_CITY_SUCCESSFUL = "GET_CITY_SUCCESSFUL"
export const GET_CITY_FAILED = "GET_CITY_FAILED"
export const GET_CITY_RESET = "GET_CITY_RESET"

